/**
 * Module - Operation Center - English
 */
export default {
  // As root-level property for $t('operationCenter.xxx')
  operationCenter: {
    expressCompany: 'Express company',
    prepaidFreight: 'Prepaid freight',
    auto_43: 'Pay',
    auto_44: 'Edit',
    auto_45: 'Details',
    auto_46: 'Ship',
    auto_47: 'Confirm receipt',
    auto_48: 'Confirm receipt',
    auto_113: 'Confirm receipt',
    auto_49: 'Cancel',
    auto_50: 'Cancel',
    auto_114: 'Cancel',
    auto_51: 'Review',
    auto_52: 'Ship',
    auto_53: 'Confirm receipt',
    auto_54: 'Pay',
    auto_55: 'Edit',
    auto_56: 'Details',
    auto_57: 'Cancel',
    auto_58: 'Details',
    auto_59: 'Cancel',
    auto_60: 'Edit',
    auto_61: 'Details',
    auto_62: 'Cancel',
    auto_63: 'Ship',
    auto_64: 'Details',
    auto_65: 'Cancel',
    auto_66: 'Details',
    auto_67: 'Details',
    auto_68: 'Details',
    auto_69: 'Details',
    auto_70: 'Confirm receipt',
    auto_71: 'Details',
    auto_72: 'Details',
    auto_73: 'Review',
    auto_74: 'Details',
    auto_75: 'Details',
    auto_76: 'Details',
    auto_77: 'Confirm receipt',
    auto_78: 'Details',
    auto_79: 'Ship',
    auto_80: 'Details',
    auto_81: 'Details',
    auto_82: 'Details',
    auto_83: 'Details',
    auto_84: 'Swap-in product shipping',
    auto_85: 'Details',
    auto_86: 'Pending payment',
    auto_87: 'Pay',
    auto_88: 'Edit',
    auto_89: 'Cancel',
    auto_90: 'Pending review',
    auto_91: 'Cancel',
    auto_92: 'Review',
    auto_93: 'Returned',
    auto_94: 'Edit',
    auto_95: 'Cancel',
    auto_96: 'Shipping',
    auto_97: 'Pending shipment',
    auto_98: 'Ship',
    auto_99: 'Shipped',
    auto_100: 'Confirm receipt',
    auto_101: 'Pending shipment',
    auto_102: 'Ship',
    auto_103: 'Shipped',
    auto_104: 'Confirm receipt',
    auto_105: 'Completed',
    auto_106: 'Cancelled',
    auto_33: 'Send verification code',
    auto_34: 'Resend',
    auto_35: 'Send verification code',
    auto_36: 'Resend',
    auto_37: 'Once the learning tablet is marked as a prototype',
    auto_38: 'Notice',
    auto_39: 'OK',
    auto_40: 'Cancel',

    auto_41: 'PO no. / transfer order no.',
    auto_42: 'Consignee',
    auto_32: 'Pending selection',
    auto_21: 'Enter code or purchase order no.',
    auto_22: 'Pending',
    auto_23: 'Selected',
    auto_24: 'Activated',
    auto_25: 'Not activated',
    auto_26: 'Activated',
    auto_27: 'Not activated',

    auto_16: 'Purchase order no.',
    auto_17: 'Agent name',
    auto_18: 'Created by',
    auto_19: 'Shipping warehouse',
    auto_20: 'Select shipping warehouse',
    auto_28: 'Delivery address',
    auto_29: 'Enter campus address',
    auto_30: 'Remark',
    auto_31: 'Enter remark (max 200 characters)',
    auto_11: 'Product name',
    auto_12: 'Quantity',
    auto_13: 'Order no.',
    auto_14: 'Order items',
    auto_15: 'Order qty pending shipment',

    auto_1: 'Purchase order no.',
    auto_2: 'Agent name',
    auto_3: 'Created by',
    auto_4: 'Shipping warehouse',
    auto_5: 'Select shipping warehouse',
    auto_6: 'Consignee',
    auto_7: 'Consignee phone',
    auto_8: 'Province / city / district',
    auto_9: 'Shipment status',
    auto_10: 'Shipment status',

    auto_107: 'Quantity',
    auto_108: 'Product',
    auto_109: 'Wang Xiaohu',
    auto_110: 'No. 351, Jinhua Road, Putuo District, Shanghai',
    auto_111: 'Wang Xiaohu',
    auto_112: 'No. 351, Jinhua Road, Putuo District, Shanghai',
    auto_115: 'Swap-out product',
    auto_116: 'Swap-in product',
    auto_117: 'Unit price',

    auto_137: 'Swap in',
    auto_138: 'Swap in',
    auto_139: 'Swap in',
    auto_140: 'Swap in',
    auto_141: 'Swap in',
    auto_142: 'Swap in',
    auto_143: 'Swap in',
    auto_144: 'Swap in',
    auto_145: 'Swap in',
    auto_146: 'Swap out',

    auto_120: 'Head office shipment',
    auto_121: 'Store receipt',
    auto_122: 'Main warehouse',
    auto_123: 'Store receipt',

    auto_126: 'Enter code',
    auto_127: 'Ship',
    auto_128: 'Ship swap-out product',
    auto_129: 'Ship swap-in product',
    auto_130: 'Unit price',

    auto_124: 'Back',
    auto_118: 'No data',
    auto_119: 'Store receipt',

    auto_134: 'Export regional agent shipment records',
    auto_135: 'Cancel failed',

    auto_136: 'Export sales shipments',

    auto_132: 'Insurance fee',
    auto_133: 'Insurance fee',

    auto_125: 'Edit failed',

    auto_131: 'Export JD warehouse shipment parameter config',

    // Regional JD ship — saleConsignmentDetailNew (avoid auto_21–27 collision with transfer dialog)
    textkwso: 'Product details',
    texti5zt: 'Related orders',
    textjenf: 'Logistics details',
    saleConsignmentDetailSendStatusPh: 'Shipment status',
    saleConsignmentDetailJdOutboundNo: 'JD warehouse outbound no.',
    saleConsignmentDetailAgentRecvWarehouse: 'Agent receiving warehouse',
    saleConsignmentDetailRemarkPh: 'Enter remark (max 200 characters)',
    saleConsignmentTraceShippingDate: 'Ship date',
    saleConsignmentTraceExpressCompany: 'Courier company',
    saleConsignmentTraceWayBill: 'Tracking no.',
    saleConsignmentTraceLogisticsStatus: 'Logistics status',
    saleConsignmentTraceShipNum: 'Shipped qty',

    // Head office shipment — stock transfer dialog (HeadOfficeModal); dedicated keys (avoid auto_* collisions)
    headOfficeTransferModalTitle: 'Stock transfer',
    headOfficeTransferModalAgentIdLabel: 'Agent ID:',
    headOfficeTransferModalProductNameLabel: 'Product name:',
    headOfficeTransferModalPONoLabel: 'PO no. / transfer order no.:',
    headOfficeTransferModalReceiverLabel: 'Consignee:',
    headOfficeTransferModalReceiverPhoneLabel: 'Consignee phone:',
    headOfficeTransferModalProvinceCityLabel: 'Province / city:',
    headOfficeTransferModalAddressLabel: 'Delivery address:',
    headOfficeTransferModalOrderQtyLabel: 'Order quantity:',
    headOfficeTransferModalShippedQtyLabel: 'Shipped quantity:',
    headOfficeTransferModalExpressCompanyLabel: 'Courier company:',
    headOfficeTransferModalSelectExpressPlaceholder: 'Select courier company',
    headOfficeTransferModalExpressNoLabel: 'Tracking no.:',
    headOfficeTransferModalFillExpressNo: 'Enter tracking number',
    headOfficeTransferModalPendingZone: 'Available',
    headOfficeTransferModalSelectedZone: 'Selected',
    headOfficeTransferModalActivated: 'Activated',
    headOfficeTransferModalNotActivated: 'Not activated',
    headOfficeTransferModalFilterSnPurchasePlaceholder: 'Enter SN or purchase order no.',
    headOfficeTransferModalTransferPending: 'Pending',
    headOfficeTransferModalTransferSelected: 'Selected',
  }
};
